import type { EventCategory } from './base';

export const AuthEvents = {
  USER_REGISTERED: {
    categories: ['all'] as EventCategory[],
    properties: {
      method: 'email' as string,
      step: 'registration' as 'registration' | 'confirmation',
    },
  },
  USER_LOGGED_IN: {
    categories: ['all'] as EventCategory[],
    properties: {
      method: 'email' as 'email' | 'employee_id',
    },
  },
  AUTH_SESSION_LOST: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      event: '' as string,
    },
  },
} as const;
